<wizard-labeled-field label="Room" [size]="fieldSize">
    <wizard-tooltip>
        Room booking integrates with your room provider to automatically book a meeting room based on capacity.
        <a href="https://faq.calendarhero.com/hc/en-us/articles/4430389115291-How-does-Room-Booking-work-" target="_blank">Learn More</a>
    </wizard-tooltip>
    <div class="ui selection dropdown" id="room" [ngClass]="{ disabled: !hasRoomProviders }">
        <i class="building icon bluegrey margin-right-10"></i>
        <input type="hidden" name="type" value="default" />
        <i class="dropdown icon"></i>
        <div class="default text"></div>
    </div>
</wizard-labeled-field>
